import { createStyles, Theme } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    root: { marginBottom: theme.spacing(3) },
    control: { marginLeft: 0 },
    icon: {},
    checkedIcon: {},
  });
